// @flow

import styled from 'styled-components';
import { clearfix, media } from 'styles/Mixins';
import { IconBackArrow } from 'styles/BackArrow';
import { Common, Auth } from 'utils/ExportCommon';
import MenuDots from 'AssetsRoot/images/homie_v3/menu_dots.svg.react';
import { font } from 'styles/Constants';

export const WrapperSpinner = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  width: 30em;
  height: 18em;
  margin-top: -9em;
  margin-left: -15em;
`;

export const StepperContent = styled.div``;

export const Container = styled.div``;

export const ContainerStepper = styled.div`
  ${props => props.loadingDepa && 'height: calc( 100vh - 81px)'};
`;

export const AvailableFrom = styled.div`
  display: inline-flex;
  display: flex;
  justify-content: space-between;
`;

export const SectionAction = styled.div`
  display: ${props => (props.purple ? 'flex' : 'inline-block')};
  width: ${props => (props.purple ? '100%' : '169px')};
  height: ${props => (props.purple ? '140px' : '')};
  background-color: ${props => (props.purple ? '#EFEFFA' : '')};
  cursor: pointer;
`;

//*************** TEXT *************//
export const RegularText = styled.h5`
  color: #4a4a4a;
  letter-spacing: 0;
  font-weight: ${props => (props.bold ? 'bold' : 'normal')};
`;

//************* PANEL ************//
export const PanelDefault = styled.div`
  border-radius: 2px;
  background-color: #ffffff;
  margin-bottom: 10px;
`;
//*********** H5 **********//

//*********** SPAN *********//
export const SpanDate = styled.span`
  color: #9b9b9b;
  font-size: 12px;
  padding-left: 15px;
  line-height: 15px;
`;

export const StyledSpanNormal = styled.span`
  color: #4a4a4a;
  font-size: 16px;
  line-height: 19px;
`;

//*************ICONS*************//
export const MenuDotsIcon = styled(MenuDots)`
  display: block;
  height: 30px;
  width: 30px;
`;

export const WhatsappIcon = styled.img.attrs({
  src: Auth.wsapp
})`
  display: block;
  height: 20px;
  width: 20px;
  margin-right: 6px;
`;

export const IconParams = styled.img.attrs({
  style: ({ width, height }) => ({
    width: width,
    height: height
  })
})`
  margin-right: 5px;
  vertical-align: text-top;
`;

export const IconWhatsapp = styled.img.attrs({
  src: Auth.wsapp
})`
  float: right;
  position: absolute;
  top: 6px;
  right: 9px;
  z-index: 3;
`;

export const Heart = styled(Common.IconHeart)`
  width: 20px;
  height: 20px;

  ${media.md`
      left: 110px;
  `};
`;

export const BackArrow = styled(IconBackArrow)`
  width: 25px;
  height: 21px;
  margin-left: 10px;
  ${media.md`
    margin: 20px 33px 18px 43px;
  `}
`;

export const BackArrowShowHome = styled(BackArrow)`
  ${media.md`
    margin: 0px 30px 0px 25px;
  `}
`;

export const IconShape = styled.img.attrs({
  src: Common.IconShape
})`
  height: 20px;
  width: 14px;
`;

export const PinIcon = styled.img.attrs({
  src: Common.PinShape
})`
  height: 20px;
  width: 14px;
  margin-top: 20px;
  ${media.md`
    float:left;
    vertical-align:middle;
    margin-right:10px;
  `}
`;

export const PinMapIcon = styled(Common.PinMapShape)`
  height: 20px;
  width: 14px;
  margin-top: 20px;
  ${media.md`
    float:left;
    vertical-align:middle;
    margin-right:10px;
  `}
`;
//*********END ICONS*************//

//*********RIGHT SIDE HELP HEADER***//
export const StyledH4 = styled.h4`
  margin: 0 0 15px;
  font-size: 16px;
  font-weight: bold;
  letter-spacing: 0.1px;
`;

export const HelpRightContainer = styled.div`
  ${media.md`
    display: block;
    background-color: #ffffff;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);
  `}
  display:none;
`;

export const HelpRightSideHeader = styled.div`
  height: 40px;
  width: 310px;
  border-radius: 2px 2px 0 0;
  background-color: #278c7e;
  color: #ffffff;
  font-size: 16px;
  font-weight: bold;
  line-height: 40px;
  padding: 0 15px;
`;

export const HelpRightSideBody = styled.div`
  padding: 20px 15px;
  width: 310px;
`;

//*********END RIGHT SIDE HELP HEADER***//

export const MapFilterType = styled.div`
  color: #4a4a4a;
  font-size: 16px;
  line-height: 19px;
  margin-bottom: 10px;
  ${media.md`
    display:none;
  `}
`;

export const TextUbicationHeadMd = styled.div`
  ${media.md`
    display: block;
    height: 22px;
    width: 78px;
    color: #4A4A4A;
    font-size: 18px;
    line-height: 22px;
    margin-bottom: 10px;
  `}
  display:none;
`;

export const TextUbicationContentMd = styled.div`
  ${media.md`
    display: block;
    height: 100%;
    width: 100%;
    color: #4A4A4A;
    font-size: 16px;
    font-weight: bold;
    line-height: 19px;
  `}
  display:none;
  height: 100%;
  width: 100%;
`;

export const LineHr = styled.div`
  ${media.md`
    display: block;
    height: 1px;
    width: 165px;
    background-color: #E9E9E9;
    margin-top: 10px;
    margin-bottom: 10px;
  `}
  display:none;
`;

export const LineHrRight = styled(LineHr)`
  ${media.md`
    width: 279px;
  `}
`;

export const TextCocreateUser = styled.div`
  color: #4a4a4a;
  font-size: 16px;
  line-height: 19px;
  margin-bottom: 5px;
  ${media.md`
    text-align: left;
    margin-bottom: 10px;
    display: none;
  `}
  display: none;
`;

export const TextColonyRectangle = styled.div`
  color: #278c7e;
  font-size: 16px;
  line-height: 19px;
  text-align: center;
  padding-top: 6px;
`;

export const TextNearColonies = styled(TextColonyRectangle)`
  text-align: left;
  color: #4a4a4a;
  padding-top: 0;
  font-size: 18px;
  margin-bottom: 10px;
`;

export const NavegationViewBar = styled.div`
  display: inline-flex;
  align-items: center;
  width: 100%;
  min-height: 60px;
  margin: 0 auto;
  margin-bottom: ${props =>
    props.marginBottomXS ? props.marginBottomXS : '12px'};
  background-color: #ffffff;
  box-shadow: 1px 1px 3px 0 rgba(0, 0, 0, 0.2);
  z-index: 2;
  ${media.md`
    display: inline-flex;
    align-items: center;
    position: fixed;
    width: 1024px;
    margin: 0;
    margin-bottom: 12px;
  `}
`;

export const BoxIcon = styled.div`
  float: left;
  width: 100px;
  height: 60px;
`;

export const NearColoniesRectangles = styled.div`
  display: flex;
  flex-wrap: nowrap;
  overflow-x: auto;
  ${media.md`
    display: block;
  `}
`;

export const ColonyRectangle = styled.span`
  display: inline-block;
  height: 35px;
  border-radius: 2px;
  background-color: #ffffff;
  border: 1px solid #278c7e;
  margin-right: 5px;
  margin-top: 5px;
  padding-left: 20px;
  padding-right: 25px;
  flex: 0 0 auto;
`;

export const TabTrigger = styled.div`
  display: flex;
  width: 85%;
  margin-left: 10px;
  float: left;
  min-height: 60px;

  ${media.md`
    width:603px;
    display: flex;
  `}
`;

export const TabTriggerItem = styled.div`
  float: left;
  min-height: 60px;
  display: flex;
  align-items: center;
  width: ${props => (props.width ? props.width : 'auto')};
  border-bottom: ${props => (props.active ? '2px solid #278C7E' : 'hidden')};
  text-align: ${props => (props.align ? props.align : 'initial')};
  color: #4a4a4a;
  font-size: 16px;
  justify-content: ${props =>
    props.justifyContent ? props.justifyContent : 'flex-start'};
  ${media.md`
    cursor: pointer;
    width:${props => (props.widthMD ? props.widthMD : 'auto')};
    justify-content:${props =>
      props.justifyContent ? props.justifyContent : 'flex-start'};
  `}
`;

export const ItemText = styled.span`
  color: #4a4a4a;
  font-size: 16px;
  display: none;
  ${media.md`
      display:block;
  `}
`;

export const ItemTextBold = styled.p`
  color: #4a4a4a;
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 0px;
`;

export const ItemTextBoldCenter = styled.p`
  color: #4a4a4a;
  font-size: ${props => (props.fSize ? props.fSize : '16px')};
  font-weight: bold;
  margin-top: 11px;
  text-align: center;
  line-height: 22px;
  ${media.md`
    margin:0;
  `};
`;

export const TabTargetItem = styled.div`
  display: ${props => (props.active ? 'block' : 'none')};
`;

export const Content = styled.div`
  width: 100%;
  margin: 0 auto;
  ${media.md`
    width: 100%;
    ${props => props.mTop && 'margin-top:20px'};
  `}
`;

export const LeftSide = styled.div`
  ${props => props.mHeigth && 'min-height: 75vh'};
  ${media.md`
    float: left;
    width: ${props => (props.insideLeft ? '100%' : '684px')};
    height: 100%;
    overflow: visible;
  `}
`;

export const FullWidth = styled.div`
  ${props => props.mHeigth && 'min-height: 75vh'};
  ${media.md`
    width:  '100%';
    height: 100%;
  `}
`;

export const FullWidthContent = styled.div`
  margin: 0 auto;
  width: 362px;
  ${media.sm`
    width: 500px;
  `};
  ${media.md`
    width: 932px;
  `}
`;

export const FullWidthContainer = styled.div.attrs({
  style: ({ isBlock }) => ({
    display: isBlock ? 'block' : 'flex'
  })
})`
  float: right;
  border-radius: 2px;
  background-color: #ffffff;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);
  width: 100%;
  padding-bottom: 20px;
  margin-bottom: 20px;
`;

export const LeftContent = styled.div`
  margin: 0 auto;
  ${media.md`
    float: right;
    width: 638px;
    margin-right: 12px;
  `}
`;

export const LeftSideContainer = styled.div.attrs({
  style: ({ isBlock }) => ({
    display: isBlock ? 'block' : 'flex'
  })
})`
  float: right;
  border-radius: 2px;
  background-color: #ffffff;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);
  width: 100%;
  padding-bottom: 20px;
  margin-bottom: 20px;
`;

export const RightSide = styled.div`
  display: ${props => (props.visibleXS ? 'block' : 'none')};
  ${media.md`
    display: block;
    float: left;
    width: 340px;
    height: 100%;
  `}
`;

export const RightContent = styled.div`
  ${media.md`
    position: fixed;
    z-index: 2;
    ${props => (props.commercial ? 'margin-top: 70px;' : '')};
  `}
`;

export const InterestPeople = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  max-width: 364px;
  height: 35px;
  margin: 0 auto;
  margin-bottom: 9px;
  background-color: #babed7;
  color: #4f5ea3;
  font-size: 16px;
  font-weight: normal;
  line-height: 35px;
  text-align: center;
  ${media.md`
    width: 300px;
    height: 60px;
    top: 60px;
    margin-bottom: 12px;
    font-size: 18px;
    font-weight: bold;
    line-height: 60px;
    letter-spacing: 1px;
  `}
`;

export const HomeDetails = styled.div`
  display: ${props => (props.visibleXS ? 'block' : 'none')};
  ${media.md`
    display: ${props => (props.visibleMD ? 'block' : 'none')};
  `};
`;

export const MapHome = styled.div`
  width: 100%;
  ${media.md`
    margin-top: 72px;
  `}
`;

export const ServiceNear = styled.div`
  ${media.md`
    width: 100%;
    margin-right: 15px;
    background-color: #f9f9f9;
    display:none;
  `}
  ${media.xs`
    background-color: #ffffff;
    padding-top: 10px;
    display:none;
  `}
`;

export const Photo = styled.img`
  width: 638px;
  max-height: 390px;
`;

export const Arrow = styled.button`
  background: none;
  width: 100%;
  height: 100%;
  border: none;
  outline: none;
  position: relative;
`;

export const ArrowWrapper = styled.div`
  ${props => props.type}: 0;
  position: absolute;
  top: 0;
  width: 27px;
  height: 98%;
  z-index: 10;
  background: none;

  &:hover {
    ${Arrow} {
      background-color: #4a4a4a;
      opacity: 0.39;
    }
  }
  svg {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    color: #ffffff;
    font-size: 16px;
  }
`;

export const ArrowWrapperDate = styled(ArrowWrapper)`
  ${props => props.type}: 0;
  cursor: pointer;
  &:hover {
    ${Arrow} {
      cursor: pointer;
    }
  }
  svg {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    color: #4a4a4a;
    font-size: 32px;
  }
`;

export const ArrowWrapperDateAppointment = styled(ArrowWrapper)`
  height: 124px;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  &:hover {
    ${Arrow} {
      cursor: pointer;
      background-color: ${props => (props.bgColor ? props.bgColor : '#F9F9F9')};
      opacity: initial;
    }
  }
  svg {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    color: #4a4a4a;
    font-size: 32px;
  }
`;

export const WrapperDataShow = styled.div`
  height: 100px;
  width: 80px;
  border-radius: 2px;
  background-color: #fcfcfc;
  border: 1px solid ${({ active }) => (active ? '#278C7E' : '#CDCDCD')};
  color: ${({ active }) => (active ? '#278C7E' : '#4a4a4a')};
  margin: 15px 8px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  cursor: pointer;
`;

export const SecondaryWrapperDataShow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  width: 175px;
  margin: -8px auto 0;
`;

export const CardHour = styled.div`
  width: 80px;
  border-radius: 2px;
  background-color: #fcfcfc;
  border: 1px solid ${({ active }) => (active ? '#278C7E' : '#CDCDCD')};
  color: ${({ active }) => (active ? '#278C7E' : '#4a4a4a')};
  margin-bottom: 10px;
  user-select: none;
  cursor: pointer;
`;

export const WeekDayData = styled.div`
  width: 80px;
  font-size: 14px;
  line-height: 17px;
  text-align: center;
`;

export const DayData = styled.div`
  height: 29px;
  width: 80px;
  font-size: 24px;
  line-height: 29px;
  text-align: center;
  margin-top: 3px;
  font-weight: bold;
`;

export const MonthData = styled.div`
  height: 15px;
  width: 80px;
  font-size: 12px;
  line-height: 15px;
  text-align: center;
`;

export const HourData = styled.div`
  height: 17px;
  width: 80px;
  font-size: 14px;
  line-height: 17px;
  text-align: center;
  padding-top: 8px;
  padding-bottom: 10px;
`;

export const SecondaryHourData = styled.div`
  font-size: 14px;
  line-height: 17px;
  text-align: center;
  padding: 3px;
`;

export const ServicesContainer = styled.div`
  display: flex;
  flex-direction: row;
  margin-bottom: 10px;
`;

export const Service = styled.div`
  display: flex;
  flex-direction: column;
  height: 60px;
  width: 80px;
  margin-right: 25px;
  ${media.md`
    margin-right:13px;
  `};
`;

export const Icon = styled.div`
  display: block;
  text-align: center;
`;

export const ServiceText = styled.p`
  color: #323232;
  font-size: 14px;
  text-align: center;
  margin: 0;
`;

export const ServiceTextBold = styled.span`
  display: ${props => (props.show ? 'block' : 'none')};
  color: #323232;
  font-size: 12px;
  font-weight: bold;
`;

export const PriceConcept = styled.div`
  display: inline-block;
  width: 50%;
`;

export const PriceText = styled.p`
  margin-bottom: 6px;
`;
export const PriceTextMarginOut = styled.p`
  margin: 0;
`;

export const Price = styled.h3`
  display: inline-block;
  color: #323232;
  font-size: 24px;
  font-weight: bold;
  margin-top: 0;
  margin-bottom: 8px;
  color: #278c7e;
  width: 90%;
  ${media.md`
    color:#323232;
  `};
`;

export const HomeCardWrapper = styled.li`
  ${media.md`
    display: inline-block;
    padding-left:5px;
  `}
`;

export const WrapperSchedule = styled.div`
  display: ${props => (props.visible ? 'block' : 'none')};
  border-radius: 2px;
  background: #fff;
`;

export const Toogle = styled.div`
  display: ${props => (props.visibleXS ? 'block' : 'none')};
  ${media.md`
    display : ${props => (props.visibleMD ? 'block' : 'none')};
  `};
`;
export const Navigation = styled.div`
  margin-bottom: 15px;
`;

export const NavigationTitle = styled.p`
  color: #A4A4A4A;
  font-size: 16px;
  font-weight: bold;
  line-height: 19px;
  height: 19px;
  display: inline-block;
`;

export const WrapperIcon = styled.div`
  margin-left: 10px;
  height: 33px;
  width: 30px;
  font-size: 22px;
  display: inline-block;
  vertical-align: middle;
  cursor: pointer;
`;

export const WrapperDate = styled.div`
  text-align: center;
  margin-bottom: 20px;
`;

export const WrapperProgressBar = styled.div`
  display: ${props => (props.show ? 'block' : 'none')};
`;

export const ProgressBar = styled.div`
  height: 6px;
  background: #e6e6e6;
`;

export const Progress = styled.div`
  width: ${props => (props.percent ? props.percent : '0%')};
  height: 100%;
  background-color: #278c7e;
`;

export const BoxTitle = styled.div`
  float: left;
  height: 60px;
  line-height: 60px;
  text-align: center;
  margin-left: 20px;
`;

export const Title = styled.p`
  color: #A4A4A4A;
  font-size: 16px;
  line-height: 19px;
  height: 19px;
  display: inline-block;
`;

export const BoxMap = styled.div`
  height: 160px;
  margin-bottom: 10px;
  position: relative;
  background: #ffffff;
`;

export const TextAssistanceConfirm = styled.p`
  color: #4a4a4a;
  font-size: 14px;
  line-height: 19px;
`;

export const TextPurpleAssistanceConfirm = styled.span`
  color: #278c7e;
  font-size: 14px;
  line-height: 19px;
  margin-left: 5px;
  cursor: pointer;
`;

export const TextBoldAssistenceConfim = styled.p`
  font-size: 16px;
  font-weight: bold;
  line-height: 19px;
  text-align: center;
  margin-bottom: 20px;
`;

export const HideWhenDepartementHaveAppointment = styled.div`
  display: ${props => (props.hide ? 'none' : 'block')};
`;

export const WrapperIconWhatsaap = styled.div`
  position: relative;
`;

export const ContainerBodyPadding = styled.div`
  padding: 60px 0 10px;
`;

export const ContainerHome = styled.div`
  ${media.md`
    position: absolute;
    top: 50%;
    transform: translate(0, -50%);
  `};
`;

export const TitleText = styled.div`
  color: #4a4a4a;
  font-size: 20px;
  font-weight: bold;
  position: absolute;
`;

//****************PHOTO BACKGROUND ***************//

export const PhotoDiv = styled.div.attrs({
  style: ({ url }) => ({
    backgroundImage: `url('${url}')`
  })
})`
  height: 100%;
  background: 50% no-repeat;
  background-size: cover;
`;

export const CicularImageView = styled(PhotoDiv)`
  height: 120px;
  width: 120px;
  margin-bottom: 4px;
  background: 50% no-repeat;
  background-size: cover;
`;

//*****************BOTONES*************** ///////
export const ButtonDefault = styled.button`
  height: 35px;
  color: #ffffff;
  border-radius: 2px;
  border: none;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.5);
  padding: 8px 0;
  text-align: center;
  font-weight: bold;
  font-size: 16px;
`;

export const SubmitButton = styled(ButtonDefault)`
  display: ${({ hidden }) => (hidden ? 'none' : 'block')};
  width: 100%;
  line-height: normal;
  margin: 30px 0 25px 0;
  background-color: #${({ bColor }) => (bColor ? bColor : '4F5EA3')};
  &:disabled {
    background-color: #ececec;
  }
`;

export const StyledButton = styled(SubmitButton)`
  width: 200px;
  margin-left: 35px;
  right: 0;
  font-weight: bold;
  box-shadow: none;
  background-color: #278c7e;
  line-height: 19px;
`;

export const WrapperButton = styled.div`
  ${media.md`
    display: none;
  `}
  display:none;
`;

export const ButtonWantVisit = styled(SubmitButton)`
  display: ${props => (props.active ? 'block' : 'none')};
  width: 200px;
  height: 40px;
  margin: 0 auto 20px auto;
  color: #ffffff;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);
  margin-bottom: ${props => (props.marginHaveAppointment ? '140px' : '20px')};
  ${media.md`
    display: ${props => (props.active ? 'none' : 'block')};
  `};
`;

export const StyledButtonHomeCard = styled(StyledButton)`
  display: inline-block;
  width: 140px;
  margin-left: 20px;
  margin-bottom: 15px;
  margin-top: 15px;
  &:disabled {
    background-color: #ffffff;
    color: rgb(84, 84, 84);
  }
  ${media.md`
    display: block;
  `}
`;

//***************Columns and group*********************//
export const ColumnContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const ColumnSection = styled.div`
  width: 33%;
`;

export const GroupLabel = styled.div`
  margin-bottom: 15px;
  margin-right: 10px;
`;

export const LabelTitle = styled.div`
  color: #797979;
  font-size: 13px;
  line-height: 17px;
`;

export const LabelContent = styled(LabelTitle)`
  color: #4a4a4a;
  padding-right: 0px;
`;

export const LabelContentBold = styled(LabelContent)`
  font-size: ${props => (props.fSize ? props.fSize : 20)}px;
  font-weight: bold;
  line-height: 24px;
  -ms-word-break: break-all;
  word-break: break-all;
  word-break: break-word;
  -webkit-hyphens: auto;
  -moz-hyphens: auto;
  -ms-hyphens: auto;
  hyphens: auto;
`;
//*********************** END **********************//

export const PipeV = styled.div`
  box-sizing: border-box;
  height: 1px;
  width: ${props => (props.auto ? '100' : '95')}%;
  margin: 0 auto;
  border: 1px solid #f2f1f1;
`;

///*******************Sections ********************//

export const SectionDisplay = styled.div`
  display: ${props => (props.show ? 'block' : 'none')};
`;

export const Section = styled.div`
  width: 100%;
  border-radius: 2px;
  background-color: #ffffff;
  margin-bottom: 10px;
  box-shadow: 0 0 1px 0 rgba(0, 0, 0, 0.5);
  ${media.md`
    width: 622px;
  `}
`;

export const SubSection = styled.div`
  padding: 0 15px;
`;

export const SectionPriceDescription = styled.div`
  margin-bottom: 6px;
`;

export const HeadSection = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 15px;
`;

export const TitleHeadSection = styled.div`
  color: #4a4a4a;
  font-size: 18px;
  line-height: 22px;
`;

export const SectionSchedule = styled.div`
  display: ${props => (props.active ? 'block' : 'none')};
`;

export const SectionServices = styled.div`
  width: 100%;
`;

export const SectionSlider = styled.div`
  width: 100%;
  margin-bottom: 9px;
  margin-top: 20px;
  position: relative;
  z-index: 0;

  ${media.md`
    float: right;
    width: 638px;
    margin-top: 72px;
    margin-right: 12px;
    position: relative;
    z-index: 0;
  `}
`;

export const SectionHomes = styled.div`
  display: none;
  margin-top: 20px;
  ${media.md`
    display: block;
    height: 260px;
    margin-left: 33px;
    margin-bottom: 15px;
    width: 94%;
  `};
`;
//***************WRAPPERS************//
export const Wrapper = styled.div`
  ${clearfix}
  padding-top: ${props => (props.paddingTop ? props.paddingTop : '60px')};
  ${media.md`
    font-family: ${font.openSans};
    min-height: 91vh;
  `}
`;

export const WrapperFlex = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 10px;
  background: #ffffff;
`;

export const ContainerHeader = styled.div`
  display: contents;
`;

export const SubHeader = styled.div`
  background: white;
  height: 60px;
`;

export const SubHeaderTitle = styled.div`
  color: #4a4a4a;
  font-size: 20px;
  line-height: 60px;
  padding: 0 40px;
`;

export const HeaderContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  min-height: 50px;
  border-radius: 2px;
  padding: 13px 0 13px 13px;
`;

export const MenuHeaderRight = styled.div`
  height: 30px;
  width: 30px;
  margin: 0 4px;
  cursor: pointer;
`;

export const HeaderContainerDropper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  margin-bottom: 20px;
`;

export const HeaderText = styled.span`
  min-height: 22px;
  color: #4a4a4a;
  font-size: 18px;
  line-height: 22px;
`;

export const HeaderTextMenu = styled.span`
  min-height: 24px;
  color: #4a4a4a;
  font-size: 20px;
  font-weight: bold;
  line-height: 24px;
  flex-basis: 0;
  flex-grow: 1;
`;

export const BodyContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: ${props => (props.pad ? '0 15px 15px;' : '15px')};
`;
